import styled, { css } from 'styled-components';
import { Link as _Link } from 'react-router-dom';
import mediaQueries from 'constants/mediaQueries';

import { Container as ContainerCommon } from 'components/shared/container/Container.styled';
import { colorBrandPrimary400 } from 'constants/colors';

export const Footer = styled.footer<{ hasExtraMargin?: boolean }>`
  display: block;
  margin: auto 0 0 0;
  padding: 60px 0 ${props => (props.hasExtraMargin ? '60px' : '40px')} 0;
  color: ${colorBrandPrimary400};

  ${mediaQueries.tabletAndLarger} {
    padding: 74px 0 ${props => (props.hasExtraMargin ? '74px' : '35px')} 0;
  }
`;

export const Container = styled(ContainerCommon)`
  display: flex;
  flex-direction: column-reverse;

  ${mediaQueries.tabletAndLarger} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  ${mediaQueries.desktop} {
    justify-content: flex-start;
  }
`;

export const Logo = styled.img`
  margin-top: 20px;
  height: 40px;

  ${mediaQueries.tabletAndLarger} {
    margin-top: 0;
  }
`;

export const Links = styled.div`
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 24px;

  ${mediaQueries.tabletAndLarger} {
    margin: 0;
  }

  ${mediaQueries.desktop} {
    margin-left: 104px;
  }
`;

const commonLinkStyles = css`
  margin-right: 32px;
  font-size: 16px;
  line-height: 40px;
  list-style-type: none;
  text-decoration: none;
`;

// react-react-dom link
export const Link = styled(_Link)`
  ${commonLinkStyles};
  color: ${({ color }) => color || colorBrandPrimary400} !important;

  &:hover {
    text-decoration: underline;
    color: ${({ color }) => color || colorBrandPrimary400} !important;
  }
`;

// normal link
export const NormalLink = styled.a`
  ${commonLinkStyles};
  color: ${({ color }) => color || colorBrandPrimary400} !important;

  &:hover {
    text-decoration: underline;
    color: ${({ color }) => color || colorBrandPrimary400} !important;
  }
`;
